import food3D from "../../images/nightmarket_dishes.png";
import dataviz3D from "../../images/dataviz-streetfood.png";

export default function About() {
  return (
    <div>
      <div className="header">
        <h1>Taiwan Street Food</h1>
        <p>
          I recently had the chance to join a team of data viz enthusiasts at
          Taiwan Data Stories to work on a project around Taiwan's night market
          snacks as a part of the 2022's #30daysofchart challenge on Twitter. We
          worked on the project for a month from March to April.
        </p>
        <p>
          I was responsible for making the 3D illustrations. I used Cinema4D to
          make a total of ten 3D renders to go long with the most popular street
          snacks ranking over the years. See live interactice website <a href="https://taiwandatastories.com/taiwan-street-food-interactive/">here</a>.
        </p>
        <div className="two-column-img">
          <img className="medium-img" src={food3D} />
          <img className="medium-img" src={dataviz3D} />
        </div>
        <div className="section-title">Collaborators</div>
        <p>Data Viz - Daisy </p>
        <p>Interactive Development - Julia </p>
        <p>Research + Writing - Eva ‍</p>
      </div>
    </div>
  );
}
